<template>
    <div class="infinite-loader">
        <div class="loader loader--grey" />
    </div>
</template>

<script>
export default {
    props: {
        offset: {
            type: Number,
            default: 100,
        },
        url: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    watch: {
        url() {
            this.loading = false;
        }
    },
    mounted() {
        window.addEventListener('scroll', this.checkInifite);
    },
    destroy() {
        window.removeEventListener('scroll', this.checkInifite);
    },
    methods: {
        checkInifite() {
            if(this.loading) {
                return;
            }

            const scrollTop = (window.pageYOffset || document.scrollTop)  - (document.clientTop || 0) || 0;
            const windowHeight = window.innerHeight;
            const bounds = this.$el.getBoundingClientRect();
            const elementRelativeToWindow = bounds.top + scrollTop;

            if((elementRelativeToWindow - this.offset) < scrollTop + windowHeight) {
                this.loading = true;
                this.$emit('hit');
            }
        }
    }
};
</script>
